<template>
  <v-app id="app">
    <navbar v-if="statusLogin"></navbar>
    <v-content class="content">
      <router-view/>
    </v-content>
    <div id="topbar" v-if="topbar" v-model="topbar">
      <div class="loading-boundary hidden ">
        <div class="announcementBar announcementBar--blue">
          <div class="announcementBar-messageContainer">
            <div class="announcementBar-message">
              <h1 class="announcement-headline announcementBar-message-headline">
                <a class="announcementBar-message-headline-link">NEW: Tasks are now easier to complete</a>
              </h1>
            <div class="announcementBar-message-body">
                <div>We've updated the task layout and actions menu, so it's easier for you to update and complete tasks.</div>
                </div>
            </div>
            <div class="mx-4">
                <v-btn class="announcementBar-actionButton" small>
                  <div class="caption">
                    Learn more
                  </div>
                </v-btn>
            </div>
          </div>
          <div @click="topbar = !topbar" class="announcementBar-closeButton">
            <v-icon small color="white">close</v-icon>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import VueSession from 'vue-session'
import navbar from './components/TheNavbar'

export default {
  /**
   * TODO:
   *
   *
   * FIXME:
   *
   */
  name: 'app',
  data() {
    return {
      statusLogin: true,
      topbar: false
    }
  },
  components: {
    navbar
  },
  props: {
    source: String
  },
  created() {
    this.checkSession()
  },
  updated() {
    this.checkSession()
  },

  methods: {
    checkSession() {
      // has login
      if (this.$session.has('userid')) {
        this.statusLogin = true
      } else {
        this.statusLogin = false
      }
    }
  }
}
</script>
<style lang="scss">
/* Css Pulgin */
@import '../node_modules/iziToast/dist/css/iziToast.min.css';
@import url('https://cdn.materialdesignicons.com/2.1.99/css/materialdesignicons.min.css');
@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

// Font-Face --------------
// THSarabunNew
@font-face {
  font-family: 'THSarabunNew';
  src: url('./assets/fonts/THSarabunNew/THSarabunNew.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/THSarabunNew/THSarabunNew.woff') format('woff'),
    url('./assets/fonts/THSarabunNew/THSarabunNew.ttf') format('truetype'),
    url('./assets/fonts/THSarabunNew/THSarabunNew.svg#THSarabunNew') format('svg');
  font-weight: normal;
  font-style: normal;
}
// DBHeavent-Bold
@font-face {
  font-family: 'DBHeavent-Bold';
  src: url('./assets/fonts/DBHeavent-Bold/DBHeavent-Bold.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/DBHeavent-Bold/DBHeavent-Bold.woff') format('woff'),
    url('./assets/fonts/DBHeavent-Bold/DBHeavent-Bold.ttf') format('truetype'),
    url('./assets/fonts/DBHeavent-Bold/DBHeavent-Bold.svg#DBHeavent-Bold') format('svg');
  font-weight: normal;
  font-style: normal;
}
// DBHeavent-Light
@font-face {
  font-family: 'DBHeavent-Light';
  src: url('./assets/fonts/DBHeavent-Light/DBHeavent-Light.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/DBHeavent-Light/DBHeavent-Light.woff') format('woff'),
    url('./assets/fonts/DBHeavent-Light/DBHeavent-Light.ttf') format('truetype'),
    url('./assets/fonts/DBHeavent-Light/DBHeavent-Light.svg#DBHeavent-Light') format('svg');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: 'Kanit';
}
.content {
  background-color: #fff;
}
::-webkit-scrollbar {
  display: none;
}
.list__tile--active {
  background-image: linear-gradient(to right, #4481eb 0%, #04befe 100%);
  &:hover {
    background-image: linear-gradient(to right, #4481eb 0%, #04befe 100%) !important;
  }
}
.list__tile {
}
.panel-fixed {
  height: 100vh;
  overflow-y: auto;
}
#topbar {
  z-index: 3;
  max-height: 160px;
  -webkit-transition: max-height 0.6s ease-out;
  transition: max-height 0.6s ease-out;
  & .announcementBar--blue {
    background: -webkit-linear-gradient(left, #9287ff, #32c1ff 100%);
    background: linear-gradient(to right, #9287ff, #32c1ff 100%);
    & .announcementBar-actionButton:not(.is-disabled) {
      background-color: #796eff;
      border-color: #796eff;
      color: #fff;
      fill: #fff;
    }
  }
  & .announcementBar {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    bottom: 0;
    & .announcementBar-messageContainer {
      -webkit-align-items: center;
      align-items: center;
      display: -webkit-flex;
      display: flex;
      -webkit-justify-content: center;
      justify-content: center;
      padding: 15px 0;
    }
    & .announcementBar-message {
      color: #fff;
      text-align: center;
    }
    & .announcementBar-message-headline-link {
      color: #fff;
      text-align: center;
      &:hover {
        text-decoration: underline;
      }
    }
    & .announcementBar-message-headline {
      font-size: 16px;
      font-weight: normal;
      margin-bottom: 5px;
    }
    & .announcementBar-message-body {
      font-size: 13px;
      font-weight: normal;
      line-height: 15px;
    }
  }
  & .announcementBar-closeButton {
    cursor: pointer;
    fill: rgba(255, 255, 255, 0.5);
    position: absolute;
    right: 15px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue